import React from 'react';
import { BookOpenIcon, GiftIcon, GlobeIcon, ZapIcon, LockIcon, InfinityIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
import { volumes, bonuses } from '../../data/content';
import { images } from '../../data/site';
const badges = [{
  icon: ZapIcon,
  label: 'Instant Digital Access'
}, {
  icon: LockIcon,
  label: 'Secure One-Time Payment'
}, {
  icon: InfinityIcon,
  label: 'Lifetime Access'
}, {
  icon: BookOpenIcon,
  label: '6 Clinical Volumes'
}, {
  icon: GiftIcon,
  label: '5 Exclusive Bonuses'
}];
export function Offer() {
  return <section id="offer" className="w-full bg-cream px-4 py-16 sm:py-20" aria-labelledby="offer-heading" data-id="element-214" data-mp="3jxme7ln6grz0">
      <div className="mx-auto max-w-2xl" data-id="element-215" data-mp="3svydec240y32">
        <p className="text-center font-display text-sm font-extrabold uppercase tracking-widest text-danger" data-id="element-216" data-mp="3swznoebaxgjq">Special launch offer</p>
        <h2 id="offer-heading" className="mt-3 text-center font-display text-[1.7rem] font-black leading-tight text-navy-950 sm:text-4xl" data-id="element-217" data-mp="1nj45ls64c5n">
          Here’s Everything You’ll Receive Today
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl border-4 border-gold-400 bg-white shadow-[0_24px_60px_-24px_rgba(10,27,56,0.45)]" data-id="element-218" data-mp="1foht46ut2fob">
          <div className="bg-navy-950 px-4 pt-6" data-id="element-219" data-mp="16m8ilgzjemax">
            <img src={images.mockup} alt="Smile Design Roadmap complete package" className="mx-auto w-full max-w-md" data-id="element-220" data-mp="16njlzfp2ls1i" />
          </div>

          <div className="p-5 sm:p-8" data-id="element-221" data-mp="1zamjc4i0fwq6">
            <div className="flex items-start justify-between gap-3 border-b border-navy-900/10 pb-4" data-id="element-222" data-mp="1zbnt85naid6b">
              <div data-id="element-223" data-mp="1uicu6qopz0oy">
                <h3 className="font-display text-lg font-black leading-snug text-navy-950" data-id="element-224" data-mp="1uhjmnnhxs75r">Smile Design Roadmap™ — Complete 6-Volume Clinical Library</h3>
                <ul className="mt-2 space-y-1" data-id="element-225" data-mp="2n071wma94ryx">
                  {volumes.map(v => <li key={v.number} className="text-sm text-ink/75" data-id="element-226" data-mp="2i8p1bzc54teh">
                      <span className="font-bold text-gold-600" data-id="element-227" data-mp="315h62a535pw5">{v.number}.</span> {v.title}
                    </li>)}
                </ul>
              </div>
              <span className="shrink-0 font-display text-lg font-black text-ink/50 line-through" data-id="element-228" data-mp="363sdke7wrob7">$197</span>
            </div>

            <h3 className="mt-5 font-display text-base font-black text-navy-950" data-id="element-229" data-mp="2weqz4sh0hezc">Your 5 Exclusive Bonuses</h3>
            <ul className="mt-2 divide-y divide-navy-900/10" data-id="element-230" data-mp="2if96g20lhhkp">
              {bonuses.map(b => <li key={b.number} className="flex items-center justify-between gap-3 py-2.5 text-[15px]" data-id="element-231" data-mp="2ndsrm07d6pc0">
                  <span className="text-ink/85" data-id="element-232" data-mp="29et44vvl8ghf">
                    <GiftIcon className="mr-1.5 inline h-4 w-4 text-gold-600" aria-hidden="true" data-id="element-233" data-mp="29g4cl8zzacev" />
                    {b.title}
                  </span>
                  <span className="shrink-0 font-bold text-ink/50 line-through" data-id="element-234" data-mp="7mohnzwuybe3">${b.value}</span>
                </li>)}
            </ul>

            <div className="mt-4 flex items-center justify-between rounded-xl bg-navy-900/5 px-4 py-3" data-id="element-235" data-mp="bmffgnksxrs4">
              <span className="text-sm font-bold uppercase text-navy-900" data-id="element-236" data-mp="1w4hhud71zsdc">Total stated value</span>
              <span className="font-display text-xl font-black text-danger line-through" data-id="element-237" data-mp="1s2w46pmp3a23">$364 USD</span>
            </div>

            <div className="mt-6 text-center" data-id="element-238" data-mp="215x7yjo38p2l">
              <p className="font-display text-base font-extrabold uppercase text-navy-900" data-id="element-239" data-mp="2143yyxq05srf">But today, your price is only…</p>
              <p className="mt-1 font-display text-7xl font-black leading-none tracking-tight text-go sm:text-8xl" data-id="element-240" data-mp="2fwnxtm64de32">
                $27<span className="ml-1 text-2xl font-extrabold text-navy-900" data-id="element-241" data-mp="2ov9grifi6v4d">USD</span>
              </p>
              <p className="mt-2 inline-block rounded-full bg-navy-900 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-gold-300" data-id="element-242" data-mp="2jwel3fwftc2u">One-time payment</p>
              <p className="mt-3 text-sm text-ink/70" data-id="element-243" data-mp="uhgsgislt1cb">No monthly subscriptions. No recurring charges.</p>
              <p className="mt-3 flex items-center justify-center gap-2 rounded-xl bg-green-50 px-3 py-2.5 text-sm font-semibold text-go-deep" data-id="element-244" data-mp="pk89wh3jmvaj">
                <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-245" data-mp="vxuk3a8x06fs" />
                Automatic currency conversion to your local currency at checkout
              </p>
            </div>

            <div className="mt-6" data-id="element-246" data-mp="15x3cvzs1nf0k">
              <ScarcityBar data-id="element-247" data-mp="15v8no99qp0qo" />
            </div>

            <div className="mt-6" data-id="element-248" data-mp="88tbnn030vai">
              <CTAButton label="Yes! Give me instant access for $27" sublabel="6 volumes + 5 bonuses · lifetime access" data-id="element-249" data-mp="89umbqd6rfrp" />
            </div>

            <div className="mt-6 rounded-2xl bg-navy-950 px-3 py-5" data-id="element-250" data-mp="d5thbwt0rw13">
              <CountdownTimer data-id="element-251" data-mp="i67egjt31lkc" />
            </div>

            <ul className="mt-6 grid grid-cols-2 gap-x-3 gap-y-2.5" data-id="element-252" data-mp="mxpff7v3vm5b">
              {badges.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-2 text-[13px] font-semibold text-navy-900" data-id="element-253" data-mp="3lohfjvezce7v">
                  <Icon className="h-4 w-4 shrink-0 text-gold-600" aria-hidden="true" data-id="element-254" data-mp="3qlr3t7qmuju4" />
                  {label}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}